import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { initAnalytics } from './lib/analytics'
import { initSentry } from './lib/sentry'
import { recoverFromChunkLoadError } from './lib/chunkLoadReload'
import App from './App.tsx'

initSentry()
initAnalytics()

// HOP-183: Vite fires this when a <link rel="modulepreload"> (or the
// dynamic import() it backs) fails to fetch — the classic symptom of a tab
// still referencing a JS chunk hash that a newer deploy has since removed
// from the server. A single reload picks up the current index.html and its
// valid hashes instead of leaving the tab stuck.
window.addEventListener('vite:preloadError', () => {
  recoverFromChunkLoadError()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
